export default __webpack_public_path__ + "static/media/donald_duck.48d35218.jpg";